export default __webpack_public_path__ + "static/media/i (27).d228e90f.jpg";